import React from 'react'
import TileIcon from '../../../assets/codicons/tile'
import ListIcon from '../../../assets/codicons/list'

import styled from 'styled-components'
import PropTypes from 'prop-types'

import { screenXS } from '../../constants'

const LayoutStyles = styled.section`
  .layout-selector li.active {
    fill: #000000;
  }
`

const defaultLayout = 'tile'

class LayoutSelector extends React.Component {
  constructor (props) {
    super(props)

    this.handleWindowResize = this.handleWindowResize.bind(this)
    this.selectLayout = this.selectLayout.bind(this)

    this.handleWindowResize()
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleWindowResize)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleWindowResize)
  }

  handleWindowResize () {
    if (window.innerWidth >= screenXS) {
      this.props.onSelect('list')
    } else {
      this.selectLayout(window.localStorage.getItem('layout') || defaultLayout)
    }
  }

  selectLayout (layout) {
    if (window.innerWidth < screenXS) {
      window.localStorage.setItem('layout', layout)
    }
    this.props.onSelect(layout)
  }

  render () {
    return (
      <LayoutStyles>
        <ul className='layout-selector'>
        <li
            className={this.props.layout === 'list' ? 'active' : null}
            onClick={() => this.selectLayout('list')}
          >
            <ListIcon />
          </li>
          <li
            className={this.props.layout === 'tile' ? 'active' : null}
            onClick={() => this.selectLayout('tile')}
          >
            <TileIcon />
          </li>
          
        </ul>
      </LayoutStyles>
    )
  }
}

LayoutSelector.propTypes = {
  onSelect: PropTypes.func,
  layout: PropTypes.string
}

export default LayoutSelector
